import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils";

export class ErrosUtils {
  static converterErroAxiosParaErroSistema(erro: any): ResponseError {
    // Erro de rede
    if (erro.response === undefined) {
      const erroDeRede = erro.code === undefined;

      if (erroDeRede) {
        return erro;

      } else if (erro.code === 'ECONNABORTED') {
        return {
          status: undefined,
          data: {
            message: 'Não foi possível realizar a requisição: A requisição demorou muito para responder. Tente novamente mais tarde.',
            details: [],
            status: undefined,
            timestamp: undefined,
          }
        }
      } else {
        return erro;
      }
    }

    return {
      status: erro.response.status,
      data: erro.response.data
    }
  }
}